import React, { useEffect, useRef, useState } from "react";
import { Swiper as SwiperType } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Scrollbar, Navigation, Pagination } from "swiper/modules";
import flower from "assets/home/fellow/flower.png";
import SwiperCore from "swiper";
import Button from "atoms/borderedButton";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import { useMakrDown } from "hooks/markDown";
import axios from "axios";


type Markdown = {
  cover: string;
  logo: string;
  title: string;
  subtitle: string;
  description: string;
  markdown: string;
};

export default function EnterprisingSwiper() {
  const swiperInstance = useRef<SwiperCore | null>(null);
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [isFirstSlide, setIsFirstSlide] = useState(true);
  const [apidata, setapidata] = useState<Markdown[]>([]);
  const navigate = useNavigate();
  const { setCaseStudy } = useMakrDown();

  const handleCaseStudy = (data: string) => {
    setCaseStudy(data);
  };

  const handleSlideChange = (swiper: any) => {
    setIsLastSlide(swiper.isEnd);
    setIsFirstSlide(swiper.isBeginning);
  };

  const fetchdetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_LOCAL_URL}/api/caseStudy/show`
      );
    
      setapidata(response.data.data);
    } catch (error: any) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchdetails();
  }, []);

  return (
    <div className=" swipercontainer">
      <Swiper
        onSwiper={(swiper: SwiperType) => (swiperInstance.current = swiper)}
        className=" sm:pl-[8%] !mt-6 lg:!pl-[6%] 2xl:!pl-[8%]  !pl-3 !pr-3 xlg:!mt-14  relative"
        modules={[Navigation, Pagination]}
        initialSlide={0}
        speed={2000}
    
        grabCursor
        slidesPerView={1}
        onSlideChange={handleSlideChange}
        spaceBetween={20}
        navigation={{
          prevEl: ".enterprisingprevBtn",
          nextEl: ".enterprisingnextBtn",
        }}
        pagination={{
          el: ".swiper-progressbar-new",
          type: "progressbar",
          progressbarOppositeClass: "fill-progressbar",
        }}
        breakpoints={{
          480: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 1.5,
            spaceBetween: 30,
          },
          960: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 1.5,
            spaceBetween: 40,
          },
          1536: {
            slidesPerView: 1.5,
            spaceBetween: 40,
          },
        }}
      >
        {apidata.map((card, index) => (
          <SwiperSlide key={index}>
            <div className="mx-auto grid lg:grid-cols-2   h-[45rem] w-full flex-col sm:mx-0 sm:h-[60rem]  md:h-[30rem] xlg:h-[34rem]">
              <div className="">
                <img
                  src={`${process.env.REACT_APP_LOCAL_URL}/${card.cover.replace(
                    /\\/g,
                    "/"
                  )}`}
                  alt={card.title}
                  className="h-full block w-full object-cover object-center sm:mt-0 relative left-[1px]"
                />
              </div>

              <div
                className={` h-[18rem] sm:h-[20rem] md:h-full ${
                  index % 2 === 0 ? "bg-[#D6DF20]" : "bg-[#39B54A]"
                } relative sm:pb-6 pt-4 `}
              >
                <div className="flex flex-col pl-5  sm:pl-10 justify-center  sm:blade-top-padding gap-2 sm:gap-5  z-10 relative ">
                
                  <div>
                    <div className="">
                      <img
                        src={`${
                          process.env.REACT_APP_LOCAL_URL
                        }/${card.logo.replace(/\\/g, "/")}`}
                        alt={card.title}
                      />
                    </div>
                    <h4 className="font-lato-bold ">{card.title}</h4>
                    <h6 className="font-lato-bold sm:text-[14.311px] ">
                      {card.subtitle}
                    </h6>
                  </div>

                  <h4 className="font-lato-regular  !font-medium w-[90%] sm:w-[70%] 2xl:w-[50%] ">
                    {card.description}
                  </h4>
                  <div className="mt-2 sm:mt-0">
                    <Link
                      onClick={() => handleCaseStudy(card.markdown)}
                      to="/case-study"
                    >
                      <Button text={"Read case study"} />
                    </Link>
                 
                  </div>
                </div>
                <img
                  className="mix-blend-luminosity absolute bottom-0 right-0 sm:w-full w-[50%] lg:w-[80%]  filter grayscale-[0.9]"
                  src={flower}
                  alt=""
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
        <div className=" relative flex justify-end lg:!pr-[10%] xl:!pr-[10%]">
          <div className=" swiper-progressbar-new  swiper-progressbar swiper-pagination-progressbar sm:[250px] !absolute !bottom-5 ps-3 !top-auto max-w-[40%]  !rounded-md md:block lg:max-w-[350px] 2xl:max-w-[500px] "></div>

          <div className="  custom-navigation mt-9 flex gap-2 sm:gap-2">
            <button
              className={`enterprisingprevBtn cursor-pointer xlg:w-16 w-10 ${
                isFirstSlide ? "opacity-40" : ""
              }`}
              aria-label="Previous slide"
            >
              <img
                src="/BudhaFellowProgram/BFP_PreviousBtn.png"
                alt="Previous Button"
                className="object-contain w-full h-full"
                 
              />
            </button>
            <button
              className={`enterprisingnextBtn cursor-pointer xlg:w-16 w-10 ${
                isLastSlide ? "opacity-40" : ""
              }`}
              aria-label="Next slide"
            >
              <img
                src="/BudhaFellowProgram/BFP_NextBtn.png"
                alt="Next Button"
                className="object-contain w-full h-full"
                 
              />
            </button>
          </div>
        </div>
       
      </Swiper>
    </div>
  );
}
